'use client';
import { motion } from 'framer-motion';
import type { XYChartSeriesLayout } from './xychart-types';
export interface XYChartLineAreaFillProps {
    series: XYChartSeriesLayout;
    safeId: string;
    hasMeasured: boolean;
    seriesOpacity: number;
}
export function XYChartLineAreaFill({ series, safeId, hasMeasured, seriesOpacity, }: XYChartLineAreaFillProps) {
    if (!series.areaPath || !hasMeasured)
        return null;
    return (
    <motion.path d={series.areaPath} fill={`url(#${safeId}-area-${series.seriesIndex})`} initial={{ opacity: 0 }} animate={{ opacity: seriesOpacity }} transition={{
            duration: 0.4,
            delay: 0.4,
            ease: 'easeOut',
        }} style={{ pointerEvents: 'none' }}/>
    );
}
